exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "upd-home-services-app {\n  --beforeHeight: 79px;\n  --afterHeight: 233px;\n}\n", ""]);

